/* Project Import will be here */
import { post, IRequest, authTokenKey } from "./index";
import {
  INewLoginParams, IRequestMobChangeParams, IUpdateMobileNoParams,
  IResetPasswordParams, INewLoginChangePasswordParams, INewLoginPasswordParams
} from "models/sessionModels";
/* Project Import will be here */

/* Check given user id exist in the system */
export const checkLoginIdExistApi = (data: INewLoginParams) => {
  const request: IRequest = { subUrl: `/Login/CheckLoginIdExist`, data };
  return post(request, false);
};

/* For New loginApi  */
export const loginNewApi = (data: INewLoginPasswordParams) => {
  const request: IRequest = { subUrl: `/login/UserAuthentication`, data };
  return post(request, false);
};

export const requestChangeMobOtpApi = (data: IRequestChangeMobNoParams) => {
  const request: IRequest = { subUrl: `/Login/RequestMobChangeOTP`, ...data };
  return post(request);
};

/* Login OTP request API */
export const requestMobChangeOTPApi = (data: IRequestMobChangeParams) => {
  const request: IRequest = { subUrl: `/Login/RequestMobChangeOTP`, ...data };
  return post(request);
};

export const changeMobileNoApi = (data: IChangeMobileNoParams) => {
  const request: IRequest = { subUrl: `/login/ChangeMobileNo`, ...data };
  return post(request);
}
export const updateMobileNoApi = (data: IUpdateMobileNoParams) => {
  const request: IRequest = { subUrl: `/login/ChangeMobileNo`, ...data };
  return post(request);
}

export const resetPasswordApi = (data: IResetPasswordParams) => {
  const request: IRequest = { subUrl: `/Login/ResetPassword`, ...data };
  return post(request);
};

export const changePasswordApi = (data: INewLoginChangePasswordParams, token: any) => {
  const request: IRequest = { subUrl: `/Login/ChangePassword`, data: data, headers: { [authTokenKey]: token } };
  return post(request);
};